export default function Tabs() {
  return null;
}


